/* eslint-disable indent */
import CMSProvider from './providers/CMSProvider';
import GeneralFactory from 'coreClasses/GeneralFactory';
import ContentHubV2Provider from './providers/ContentHubV2Provider/ContentHubV2Provider';

/**
 * Represents CMSProvidersFactory
 */
class CMSProvidersFactory extends GeneralFactory {
	/**
	 * Creates CMS provider
	 * @param {String} providerName Provider name
	 * @returns {CMSProvider}
	 */
	create(providerName) {
		switch (providerName) {
			case 'ContentHubV2':
				return new ContentHubV2Provider(this.managerRepository);
			default:
				return new CMSProvider(this.managerRepository);
		}
	}
}

export default CMSProvidersFactory;
